
export const KEYBE_CHAT_BOT_INTEGRATION_SRC = "https://storage.googleapis.com/keybe-conversations/comfama_integration.js"
